import React, { useContext, useEffect, useState } from 'react'
import { Alert, Button, Modal, ModalBody } from 'reactstrap'
import EmailIcon from '../../../assets/img/svg/email-icon.svg'
import CallIcon from '../../../assets/img/svg/call-icon.svg'
import MapIcon from '../../../assets/img/svg/map-icon.svg'
import HouseIcon from '../../../assets/img/svg/house-icon.svg'
import CleanIcon from '../../../assets/img/svg/clean-icon.svg'
import CloseIcon from '../../../assets/img/svg/close-icon.svg'
import { useNavigate, useParams } from 'react-router-dom'
import { SpinnerContext } from '../../../context/spinnerContext'
import { useDispatch, useSelector } from 'react-redux'
import {
  deleteClient,
  getAllClientsReviews,
  getClienInfo,
  getUpcomingCleaning,
  updateClientStatus,
  updateInvoicePayment
} from '../../../redux/slices/clientSlice'
import { appendImageURL, convertTimestampToDate, getUserRole, hasAccess, maskPhoneNumber } from '../../../helper/function'
import { errorToast, successToast } from '../../../util/Toast/toast'
import DeletePopup from '../../../component/deletePopup'
import CustomModal from '../../../component/customModal'
import AddStrike from './addStrike'
import { defaultUserImg } from '../../../helper/imagepath'
import Property from '../property'
import UpcomimngCleaning from '../upcomingCleaning'
import CommonReviewSlider from '../../../component/sliders/commonReviewSlider'
import RatingDisplay from '../../../component/rating'

const ClientInfo = () => {
  const { client_id } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { changeLoader } = useContext(SpinnerContext)
  const { clientInfo, allUpcomingCleaning, clientReviews } = useSelector(({ client }) => client)
  const [isRefresh, setIsRefresh] = useState(false)

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const openDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen)

  const [isDeleteModalForFreezeClientOpen, setIsDeleteModalForFreezeClientOpen] = useState(false)
  const openFreezeClientModal = () => setIsDeleteModalForFreezeClientOpen(!isDeleteModalForFreezeClientOpen)

  const [showStrikeModal, setShowStrikeModal] = useState(false)
  const toggleStrikeModal = () => setShowStrikeModal(!showStrikeModal)

  const [currentPage, setCurrentPage] = useState(allUpcomingCleaning?.currentpage || 1)
  const [itemsPerPage] = useState(4 || allUpcomingCleaning?.currentRecords || 10)

  const [upcomingRefresh, setUpcomingRefresh] = useState(true)

  const { client, properties } = clientInfo || []

  useEffect(() => {
    if (client_id) {
      changeLoader(true)
      dispatch(getClienInfo(client_id))
        .then((response) => {
          changeLoader(false)
          if (response?.payload?.statusText === 'Not Found' && response?.payload?.status === 404) {
            navigate('/clients', { replace: true })
          }
        })
        .catch(() => {
          console.log('Error found...')
          changeLoader(false)
        })
    }
  }, [isRefresh])

  useEffect(() => {
    if (!upcomingRefresh) {
      return
    }
    const data = {
      client_id: client_id,
      params: {
        page: currentPage,
        limit: itemsPerPage
      }
    }
    if (hasAccess('upcomingSchedule', getUserRole())) {
      dispatch(getUpcomingCleaning(data))
        .then(() => {
          changeLoader(false)
          setUpcomingRefresh(false)
        })
        .catch(() => {
          changeLoader(false)
          setUpcomingRefresh(false)
        })
    }
  }, [currentPage, itemsPerPage, isRefresh, upcomingRefresh])

  const onDelete = () => {
    if (client_id) {
      changeLoader(true)
      dispatch(deleteClient(client_id)).then(({ payload, error }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          openDeleteModal()
          successToast(payload?.data?.status_message || 'Success!')
          window.history.back()
          navigate('/clients', { replace: true })
        } else {
          openDeleteModal()
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
    }
  }

  const handleFreezeClient = () => {
    setIsRefresh(false)
    changeLoader(true)
    const payloaddata = {
      data: { isFreezedClient: !client?.is_freezed_client },
      client_id: client_id
    }
    dispatch(updateClientStatus(payloaddata))
      .then(({ payload, error }) => {
        if (payload?.status === 200) {
          openFreezeClientModal()
          successToast(payload?.data?.status_message || 'Success!')
          setIsRefresh(true)
        } else {
          errorToast(payload?.data?.status_message || error?.message)
        }
        changeLoader(false)
      })
      .catch(() => {
        changeLoader(false)
      })
  }

  const handleUpdatePayemnet = () => {
    setIsRefresh(false)
    const payloaddata = {
      data: { invoicePayment: !client?.invoice_payment },
      id: client_id
    }
    dispatch(updateInvoicePayment(payloaddata))
      .then(({ payload, error }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          setIsRefresh(true)
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
      .catch(() => {
        changeLoader(false)
      })
  }

  return (
    <div className="page-wrapper customers">
      <div className="content">
        {/* Header Title Start */}
        <div className="title_header">
          <h5 className="sec_title_text d-flex align-items-center" onClick={() => navigate(`/clients`)}>
            <i className="fa fa-angle-left fs-5 me-2" aria-hidden="true"></i>
            Back to Clients
          </h5>

          {hasAccess('clientsAction', getUserRole()) && (
            <div className="multiple_btn_div">
              {client?.is_freezed_client === false && (
                <>
                  <Button
                    className="btn btn-primary btn-small"
                    type="button"
                    onClick={() => {
                      toggleStrikeModal()
                    }}
                  >
                    Strike Client
                  </Button>
                  <Button className="btn btn-primary dark_gray_btn btn-small" onClick={() => handleUpdatePayemnet()}>
                    Manually Invoice : {client?.invoice_payment ? 'On' : 'Off'}
                  </Button>
                </>
              )}
              <Button
                className={client?.is_freezed_client ? 'btn btn-primary btn-small' : 'btn btn-primary sky_btn btn-small'}
                onClick={() => openFreezeClientModal()}
              >
                {client?.is_freezed_client ? `Active` : 'Freeze Client'}
              </Button>
            </div>
          )}
        </div>
        {/* Header Title End */}

        {/* User Details Start */}
        <div className="common_card_div mb-4">
          <div className="user_details_main_div">
            <div className="user_details_header">
              <div className="user_img_div">
                <div className="img_div">
                  <img className="img-fluid" src={defaultUserImg} alt="Image" />
                </div>
                <div className="user_right_contains">
                  <h6>
                    {client?.first_name} {client?.last_name}
                  </h6>
                  <div className="review_star">
                    <RatingDisplay selectedValue={client?.rating} />
                  </div>
                </div>
              </div>
              <div className="user_date_div">
                <h5>
                  <span>With Us: </span>
                  {client?.created_at ? convertTimestampToDate(client?.created_at) : 'N/A'}
                </h5>
              </div>
              {hasAccess('clientsAction', getUserRole()) && (
                <div className="action_div">
                  <div
                    className="delete_btn_div"
                    onClick={() => {
                      openDeleteModal()
                    }}
                  >
                    {/* <i className="fa fa-trash" aria-hidden="true"></i> */}
                    <i className="fas fa-trash-alt"></i>
                  </div>
                  <div></div>
                </div>
              )}
            </div>
            <div className="user_details_footer">
              <div className="left_sec_div">
                <div className="user_details_box">
                  <div className="icon_box_div">
                    <img className="img-fluid" src={EmailIcon} alt="Image" />
                  </div>
                  <h6>{client?.email ? client?.email : 'N/A'}</h6>
                </div>
                <div className="user_details_box">
                  <div className="icon_box_div">
                    <img className="img-fluid" src={CallIcon} alt="Image" />
                  </div>
                  <h6>{client?.contact_no ? maskPhoneNumber(client?.contact_no) : 'N/A'}</h6>
                </div>

                {hasAccess('clientAddressAccess', getUserRole()) && (
                  <div className="user_details_box">
                    <div className="icon_box_div">
                      <img className="img-fluid" src={MapIcon} alt="Image" />
                    </div>
                    <h6>{client?.personal_address ? client?.personal_address : 'N/A'}</h6>
                  </div>
                )}
              </div>
              <div className="right_sec_div">
                <div className="user_details_box">
                  <div className="icon_box_div">
                    <img className="img-fluid" src={HouseIcon} alt="Image" />
                  </div>

                  <h6>{clientInfo?.propertiesCount || 0} property</h6>
                </div>
                <div className="user_details_box">
                  <div className="icon_box_div">
                    <img className="img-fluid" src={CleanIcon} alt="Image" />
                  </div>

                  <h6>{clientInfo?.totalCleanings || 0} cleanings</h6>
                </div>
                <div className="user_details_box">
                  <div className="icon_box_div">
                    <img className="img-fluid" src={CloseIcon} alt="Image" />
                  </div>
                  <h6>{`${client?.strikes || 0} strikes`}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* User Details End */}

        {/* Upcoming Cleanings Start */}
        {hasAccess('upcomingSchedule', getUserRole()) && (
          <UpcomimngCleaning
            allUpcomingCleaning={allUpcomingCleaning}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setUpcomingRefresh={setUpcomingRefresh}
          />
        )}
        {/* Upcoming Cleanings End */}

        {/* Reviews Start */}

        <CommonReviewSlider
          id={client_id}
          fetchReviews={getAllClientsReviews}
          reviewDataSelector={() => clientReviews?.cleaningReviewData}
          profileImageSelector={(review) => (review?.cleaners?.profile_image ? appendImageURL(review?.cleaners?.profile_image) : defaultUserImg)}
          nameSelector={(review) =>
            review?.cleaners?.first_name ? `${review?.cleaners?.first_name || ''} ${review?.cleaners?.last_name || ''}` : `N/A`
          }
          totalRecords={clientReviews?.totalRecords}
        />

        {/* Reviews End */}

        {/* Properties Start */}
        <Property setIsRefresh={setIsRefresh} client_id={client_id} properties={properties} setUpcomingRefresh={setUpcomingRefresh} />
        {/* Properties End */}
      </div>
      {isDeleteModalOpen && (
        <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={openDeleteModal}>
          <Alert color="warning mb-4">Once delete client,no longer have access to the schedule and cleaning details</Alert>
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => setIsDeleteModalOpen(false)}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger common-field-btn w-100"
              onClick={() => {
                onDelete()
              }}
            >
              Delete
            </button>
          </div>
        </DeletePopup>
      )}

      {isDeleteModalForFreezeClientOpen && (
        <Modal size={'md'} centered isOpen={isDeleteModalForFreezeClientOpen} toggle={openFreezeClientModal}>
          <ModalBody className="p-5 ">
            <div className="form-header">
              <h3 className="modal_title_text text-center">Confirmation</h3>
              <p className="modal_highlight_text text-center mb-4">
                {client?.is_freezed_client ? 'Are you sure you want to activate this client?' : 'Are you sure you want to freeze this client?'}
              </p>
              <Alert color="warning">
                {client?.is_freezed_client
                  ? 'Activating the client will restore access to schedule new properties and re-enable notifications, activity logs, chat rooms, and messaging features associated with their account.'
                  : 'Freezing will permanently delete all upcoming property schedules, notifications, activity logs, chat rooms, chat members, and messages linked to their schedule.'}
              </Alert>
            </div>
            <div className="multi_btn_div">
              <button type="button" className="btn common-outline-btn w-100" onClick={() => setIsDeleteModalForFreezeClientOpen(false)}>
                No
              </button>
              <button
                type="button"
                className="btn btn-danger common-field-btn w-100"
                onClick={() => {
                  handleFreezeClient()
                }}
              >
                Yes
              </button>
            </div>
          </ModalBody>
        </Modal>
      )}
      {showStrikeModal && (
        <CustomModal isOpen={showStrikeModal} toggle={toggleStrikeModal} title={`Add Strike`} size="md">
          <AddStrike toggleStrikeModal={toggleStrikeModal} setIsRefresh={setIsRefresh} client_id={client_id} />
        </CustomModal>
      )}
    </div>
  )
}

export default ClientInfo
